import { NgModule } from '@angular/core';
import { environment } from 'src/environments/environment';
import { CommonModule } from '@angular/common';

import { WebRoutingModule } from './web-routing.module';
import { HomeComponent } from './home/home.component';
import { CoreModule } from '../../core/core.module';
import { PrincipalSliderComponent } from './components/principal-slider/principal-slider.component';
import { SlideCardsComponent } from './home/components/slide-cards/slide-cards.component';
import { SubscribeComponent } from './home/components/subscribe/subscribe.component';
import { SlideTextComponent } from './home/components/slide-text/slide-text.component';
import { SlidePeopleComponent } from './components/slide-people/slide-people.component';
import { TitleRowComponent } from './home/components/title-row/title-row.component';
import { PosicionamientoComponent } from './components/posicionamiento/posicionamiento.component';
import { WidgetModule } from './components/widget/widget.module';
import { ModalSubscribeComponent } from './home/components/modal-suscribe/modal-suscribe.component';
import { HomeSegurosComponent } from './seguros/home-seguros/home-seguros.component';
import { SingleSegurosComponent } from './seguros/single-seguros/single-seguros.component';
import { CoberturaVideoComponent } from './seguros/components/cobertura-video/cobertura-video.component';
import { ProximaAventuraComponent } from './seguros/components/proxima-aventura/proxima-aventura.component';
import { PreguntasFrecuentesComponent } from './seguros/components/preguntas-frecuentes/preguntas-frecuentes.component';
import { ProductsSegurosComponent } from './seguros/components/products-seguros/products-seguros.component';
import { SingleBeneficiosComponent } from './seguros/components/single-beneficios/single-beneficios.component';
import { CardSeguroLeftComponent } from './seguros/components/card-seguro-left/card-seguro-left.component';
import { CardSeguroRightComponent } from './seguros/components/card-seguro-right/card-seguro-right.component';
import { PagesModule } from './pages/pages.module';

import { PromoProductsComponent } from './home/components/promo-products/promo-products.component';
import { HomeSucursalesComponent } from './sucursales/home-sucursales/home-sucursales.component';
import { FormFilterSucursalComponent } from './sucursales/componets/form-filter/form-filter.component';
import { SucFiltredComponent } from './sucursales/componets/suc-filtred/suc-filtred.component';
import { SucMapComponent } from './sucursales/componets/suc-map/suc-map.component';

import { AgmCoreModule } from '@agm/core';
import { VgCoreModule } from 'videogular2/core';
import { VgControlsModule } from 'videogular2/controls';
import { GeneralComponentsModule } from './components/General/components_general.module';
import { AgmDirectionModule } from 'agm-direction';
import { OtherPageComponent } from './other_page/other_pages.component';
import { HeaderComponent } from './seguros/home-seguros/header/header.component';
import { CuerpoComponent } from './seguros/home-seguros/cuerpo/cuerpo.component';
import { FotosComponent } from './seguros/home-seguros/cuerpo/fotos/fotos.component';
import { CoberturaComponent } from './seguros/home-seguros/cuerpo/cobertura/cobertura.component';
import { FooterComponent } from './seguros/home-seguros/footer/footer.component';
import { LoaderComponent } from './seguros/home-seguros/cuerpo/loader/loader.component';
import { ThankyoupageComponent } from './seguros/home-seguros/cuerpo/thankyoupage/thankyoupage.component';
import { RejectedComponent } from './seguros/home-seguros/cuerpo/rejected/rejected.component';

@NgModule({
    imports: [
        CommonModule,
        WebRoutingModule,
        CoreModule,
        WidgetModule,
        PagesModule,
        AgmCoreModule.forRoot({
            apiKey: environment.map_key
        }),
        AgmCoreModule,
        AgmDirectionModule,
        VgCoreModule,
        VgControlsModule,
        GeneralComponentsModule
    ],
    declarations: [
        // Componentes
        HomeComponent,
        PrincipalSliderComponent,
        SlideCardsComponent,
        SubscribeComponent,
        ModalSubscribeComponent,
        SlideTextComponent,
        SlidePeopleComponent,
        TitleRowComponent,
        PosicionamientoComponent,
        CoberturaVideoComponent,
        ProximaAventuraComponent,
        CardSeguroLeftComponent,
        CardSeguroRightComponent,
        ProductsSegurosComponent,
        PreguntasFrecuentesComponent,
        // Components seguros
        PromoProductsComponent,
        // Components sucursales
        FormFilterSucursalComponent,
        SucFiltredComponent,
        SucMapComponent,

        // Paginas
        HomeSegurosComponent,
        SingleSegurosComponent,
        SingleBeneficiosComponent,
        HomeSucursalesComponent,
        OtherPageComponent,
        HeaderComponent,
        CuerpoComponent,
        FotosComponent,
        CoberturaComponent,
        FooterComponent,
        LoaderComponent,
        ThankyoupageComponent,
        RejectedComponent
    ],
    exports: [
        // LoadingComponent
    ]
})
export class WebModule { }
